<script>
import { authMethods } from '@state/helpers'

export default {
  name: 'Login',

  page: {
    title: 'Log in',
  },

  data() {
    return {
      userNameOrEmailAddress: '',
      password: '',
      authError: null,
      tryingToLogIn: false,
    }
  },

  computed: {
    placeholders() {
      return process.env.NODE_ENV === 'production'
        ? {}
        : {
            userNameOrEmailAddress: 'Use "" to log in with the mock API',
            password: 'Use "" to log in with the mock API',
          }
    },
    url() {
      return window.location.hostname
    },
  },

  methods: {
    ...authMethods,
    // Try to log the user in with the userNameOrEmailAddress
    // and password they provided.
    tryToLogIn() {
      this.tryingToLogIn = true
      // Reset the authError if it existed.
      this.authError = null
      return this.logIn({
        userNameOrEmailAddress: this.userNameOrEmailAddress,
        password: this.password,
      })
        .then((token) => {
          this.tryingToLogIn = false

          // Redirect to the originally requested page, or to the home page
          this.$router.push(this.$route.query.redirectFrom || { name: 'Device State' })
        })
        .catch((error) => {
          this.tryingToLogIn = false
          this.authError = error
        })
    },
  },
}
</script>

<template>
  <div class="app flex-row align-items-center animated fadeIn dots">
    <div class="container">
      <b-row class="justify-content-center">
        <b-col md="8">
          <b-card-group>
            <b-card no-body class="p-4">
              <b-card-body>
                <b-form @submit.prevent="tryToLogIn">
                  <h1>Hello</h1>
                  <p class="text-muted">Sign In to your account</p>
                  <b-input-group class="mb-3">
                    <b-input-group-prepend
                      ><b-input-group-text><i class="icon-user"></i> </b-input-group-text>
                    </b-input-group-prepend>
                    <b-form-input
                      v-model="userNameOrEmailAddress"
                      name="userNameOrEmailAddress"
                      :placeholder="placeholders.userNameOrEmailAddress"
                      type="text"
                      class="form-control"
                      autocomplete="username  OrEmail Address"
                    />
                  </b-input-group>
                  <b-input-group class="mb-4">
                    <b-input-group-prepend>
                      <b-input-group-text>
                        <i class="icon-lock"></i>
                      </b-input-group-text>
                    </b-input-group-prepend>
                    <b-form-input
                      v-model="password"
                      name="password"
                      type="password"
                      :placeholder="placeholders.password"
                      class="form-control"
                      autocomplete="current-password"
                    />
                  </b-input-group>
                  <b-row>
                    <b-col cols="6">
                      <b-button
                        :disabled="tryingToLogIn"
                        type="submit"
                        variant="primary"
                        class="px-4"
                      >
                        Sign In
                      </b-button>
                    </b-col>
                    <b-col cols="6" class="text-right">
                      <!--<b-button v-if="authError" variant="link" class="px-0"
                        >Forgot password?</b-button
                      >-->
                    </b-col>
                  </b-row>
                </b-form>
              </b-card-body>
            </b-card>
            <b-card
              no-body
              class="text-white bg-gray-dark py-5 d-md-down-none"
              style="width:44%"
            >
              <b-card-body class="text-center">
                <img
                  class=" align-middle"
                  src="@assets/images/logo.png"
                  height="64"
                  alt="Open Industry"
                />
                <p class="text-center">IIoT For Manufacturing</p>
              </b-card-body>
              <p></p>
              <span class="text-center">Version 1.4.1.1 {{ url }}</span>
              <span class="text-center">&copy; CNC Data 2020</span>
              <span class="text-center">Open Industry&reg; CNC Data 2020</span>
            </b-card>
          </b-card-group>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<style lang="scss">
.dots {
  background-position: left top, right bottom;
  background-size: auto 300px;
  background-image: url(/assets/images/dotsLeft.svg), url(/assets/images/dotsRight.svg);
}
</style>
